import { replaceChildrenWithClones } from "../../../helpers/replaceChildrenWithClones";
import { mirrorCloneX } from "../../cloneObject";

export default [
    {
        key: "stol__psm",
        extra: (el) => {
            replaceChildrenWithClones(el); // TODO КОСТЫЛЬ
        },
    },
    {
        key: "tumba",
        allArray: "allTumbaSP",
        activeArray: "activeTumbaSP",
        position: "bottom",
        extra: (el) => {
            const newName = `${el.name}__left`;
            el.name = newName;
            el.userData.name = newName;
            const rightTumba = mirrorCloneX(el, newName);
            rightTumba.name = newName.replace("__left", "__right");
            rightTumba.userData.allFolderName = "allTumbaSP";
            rightTumba.userData.activeFolderName = "activeTumbaSP";
            // rightTumba.userData.allFolderName = "allTumbaRight";
            // rightTumba.userData.activeFolderName = "activeTumbaRight";
            rightTumba.userData.isBottom = true;
            rightTumba.userData.name = rightTumba.name;
            servObj.allTumbaSP.push(rightTumba);
        },
    },
    {
        key: "ruchka",
        allArray: "allRuchkaSP",
        activeArray: "activeRuchkaSP",
        position: "bottom",
    },
];
